import {Form} from "react-bootstrap";
import React from "react";

const RetroFormItem = ({label, mandatory, valueField}) => {
    if (mandatory) {
        const existingInputAttr = valueField.props.inputAttr || {};
        const existingClass = existingInputAttr.class || '';
        const newInputAttr = {
            ...existingInputAttr,
            class: existingClass ? `${existingClass} required-field-value` : 'required-field-value'
        };
        let el = React.cloneElement(valueField, {
            inputAttr: newInputAttr
        });
        return (
            <Form.Group className="mb-2">
                <Form.Label column={'sm'}>
                    {label}
                    <span className="required-field-label">*</span>
                </Form.Label>
                {el}
            </Form.Group>
        )

    }
    return (
        <div className="mb-2">
            <Form.Label column={'sm'}>
                {label}
            </Form.Label>
            {valueField}
        </div>
    )

}

export default RetroFormItem;

export const FormGroup = ({
                              label,
                              labelField: LabelField = <CustomFormLabel name={label}/>,
                              valueField: ValueField,
                          }) => {
    return (
        <Form.Group className="mb-2">
            {LabelField}
            {ValueField}
        </Form.Group>
    );
};

export const CustomFormLabel = ({name}) => {
    return <Form.Label column={'lg'}>{name}</Form.Label>;
};

export const CustomRequiredFormLabel = ({name}) => {
    return (
        <Form.Label column={'lg'}>
            {name}
            <span className="required-field">*</span>
        </Form.Label>
    );
};
